import { Identity, User } from 'shared/types'
import { ProviderIcon } from 'shared'
import { useRecordContext } from 'react-admin'
import React, { FC } from 'react'

type IdentitiesFieldProps = {
  source: string
}

export const IdentitiesField: FC<IdentitiesFieldProps> = ({ source }) => {
  const record = useRecordContext()
  if (!record) return null

  return (
    <span style={{ display: 'flex' }}>
      {record[source].map((identity: Identity, i: number) => {
        return <ProviderIcon key={i} provider={identity.provider} style={{ marginRight: 10 }} />
      })}
    </span>
  )
}
